<template>
  <a :href="result.detailPage" class="instagram-modal-product" @click="eCommerceSend">
    <span class="instagram-modal-product__header">
      <DefImg :result="result.picture" />
      <GiaPhoto v-if="result.isGia" />
    </span>
    <span class="instagram-modal-product__footer">
      <DefColorsSmall :result="result" />
      <span class="instagram-modal-product__name">
        {{ result.type }}
      </span>
      <span class="instagram-modal-product__collection">
        {{ result.collection.name }}
      </span>
      <span v-if="result.price" class="instagram-modal-product__prices">
        <DefPrice v-if="result.price.printPrice">
          {{ result.price.printPrice }}
        </DefPrice>
      </span>
    </span>
  </a>
</template>

<script lang="ts" setup>
import DefImg from '@components/Def/DefImg/DefImg.vue';
import GiaPhoto from '@components/Product/GiaPhoto.vue';
import DefColorsSmall from '@components/Def/DefColors/DefColorsSmall.vue';
import DefPrice from '@components/Def/DefPrice/DefPrice.vue';
import Analytics from '@/utils/Analytics/Analytics';

const props = defineProps(['result']);

const eCommerceSend = () => {
  Analytics.clickOnProduct(props.result);
};
</script>

<style lang="scss" scoped>
.instagram-modal-product {
  display: grid;
  grid-template-columns: 100px minmax(0, 1fr);
  grid-column-gap: 16px;
  align-items: center;
  @include point-md {
    grid-template-columns: minmax(0, 1fr);
    padding: 16px;
  }
  &:hover {
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border: 1px solid var(--background-beige);
      animation: clippath 3s linear reverse;
      pointer-events: none;
    }
  }
  @keyframes clippath {
    0%,
    100% {
      clip-path: inset(0 0 95% 0);
    }
    25% {
      clip-path: inset(0 95% 0 0);
    }
    50% {
      clip-path: inset(95% 0 0 0);
    }
    75% {
      clip-path: inset(0 0 0 95%);
    }
  }
  &__header {
    @include point-md {
      margin-bottom: 12px;
    }
  }
  &__footer {
    display: flex;
    flex-direction: column;
    @include point-md {
      align-items: center;
    }
  }
  &__name {
    font-size: 16px;
    font-weight: 500;
    line-height: 125%; /* 20px */
    text-transform: uppercase;
    margin-bottom: 8px;
  }
  &__collection {
    font-size: 12px;
    font-weight: 500;
    line-height: 125%; /* 15px */
    text-transform: uppercase;
    color: var(--color-dark-grey);
    margin-bottom: 12px;
    @include point-md {
      margin-bottom: 16px;
    }
  }
  :deep(.def-colors-small) {
    margin-bottom: 12px;
  }
  :deep(.gia-photo) {
    position: absolute;
    right: 12px;
    bottom: 12px;
  }
  //display: grid;
  //grid-template-columns: 100px 1fr;
  //grid-column-gap: 10px;
  //position: relative;
  //max-width: calc(188px + 32px);
  //padding: 16px;
  //margin: 0 auto;
  //@include point-md {
  //  grid-template-columns: 1fr;
  //}
  //&:hover {
  //  &::before {
  //    content: '';
  //    position: absolute;
  //    top: 0;
  //    left: 0;
  //    right: 0;
  //    bottom: 0;
  //    border: 1px solid var(--background-beige);
  //    animation: clippath 3s linear reverse;
  //    pointer-events: none;
  //  }
  //}
  //@keyframes clippath {
  //  0%,
  //  100% {
  //    clip-path: inset(0 0 95% 0);
  //  }
  //  25% {
  //    clip-path: inset(0 95% 0 0);
  //  }
  //  50% {
  //    clip-path: inset(95% 0 0 0);
  //  }
  //  75% {
  //    clip-path: inset(0 0 0 95%);
  //  }
  //}
  //&__footer {
  //  display: flex;
  //  flex-direction: column;
  //  justify-content: center;
  //  @include point-md {
  //    align-items: center;
  //    justify-content: flex-start;
  //  }
  //}
  //&__name {
  //  font-weight: 600;
  //  font-size: rem(16);
  //  line-height: 100%;
  //  letter-spacing: 0.04em;
  //  text-transform: uppercase;
  //  margin-bottom: 8px;
  //  overflow: hidden;
  //  height: 18px;
  //  @include point-md {
  //    font-size: rem(14);
  //    height: 16px;
  //  }
  //}
  //&__collection {
  //  font-size: rem(12);
  //  letter-spacing: 0.08em;
  //  text-transform: uppercase;
  //  color: var(--color-dark-grey);
  //  @include point-md {
  //    font-size: rem(11);
  //    line-height: 110%;
  //  }
  //}
  //&__header {
  //  display: flex;
  //  align-items: center;
  //  justify-content: center;
  //  margin-bottom: 7px;
  //  position: relative;
  //}
  //:deep(.def-colors-small) {
  //  margin-bottom: 12px;
  //}
  //:deep(.gia-photo) {
  //  position: absolute;
  //  right: 12px;
  //  bottom: 12px;
  //}
}
</style>
